export const EMPTY_STRING = '';

export const DEFAULT_EVENT = {
  event: '',
  eventCategory: '',
  eventAction: '',
  eventLabel: '',
};

export const DEFAULT_NAVIGATION_EVENT = {
  id: '',
  userType: '',
  country: '',
  pageType: '',
};

export const DEFAULT_SESSION = {
  accountCode: '',
  service: '',
  username: '',
};
